import { BasicUserCollectionModel } from '@/modules/user/models/user-collection.model'
import { Data } from '@/modules/shared/models/data'

export enum DepartmentStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export enum DepartmentIdModel {
  CONTENT_CAMPAIGN = 4,
  CONTENT_ITEM = 3,
}

export interface BasicDepartmentResourceModel {
  id: number,
  title: string
}

export interface BasicDepartmentResourceModel {
  id: number,
  title: string
}

export interface DepartmentResourceModel {
  active: boolean
  auto_message: string | null
  chat_id: string | null
  contactable: boolean
  description: string | null
  id: null
  send_auto_message: boolean
  supporters: BasicUserCollectionModel[]
  supporters_count: number
  telegram_activation_code: string
  tickets_count: number
  title: string
}

export type DepartmentResourceType = Data<DepartmentResourceModel>
